import React from 'react'

import { useMultiSelectState } from '../../packages/kiti/components/multiSelect/MultiSelectHandler'
import IconButton from './IconButton'

const MultiSelectToggler = () => {
  const { isSelecting, toggleSelectionMode } = useMultiSelectState() || {}
  const label = isSelecting ? 'Desativar seleção' : 'Seleção em massa'
  const color = isSelecting ? 'red' : undefined
  const icon = isSelecting ? 'BsXSquare' : 'BsCheck2Square'

  return (
    <>
      <IconButton icon={icon} label={label} color={color} transparent noWrap onClick={toggleSelectionMode} />
    </>
  )
}

export default MultiSelectToggler
